export default "dist/images/block-accordion-colored-hover.ba71665.png";